import { GoToListPageButton } from '../../../../components/common/buttons/GoToListPageButton';
import { SwiperItemContainer } from '../../../../components/common/itemContainer/SwiperItemContainer';
import { IProduct } from '../../../../interfaces/Product.interfaces';
import { IProductForOverviewCard, ProductOverviewCard } from './ProductOverviewCard';

const SLIDE_WIDTH = 300;
const SLIDE_HEIGHT = 387.8;

interface ProductOverviewCardSwiperProps {
  products: IProduct[];
  pageType: 'home' | 'pdp' | 'mpdp';
  category: 'pluva' | 'partner';
}

export const ProductOverviewCardSwiper = ({ products, pageType, category }: ProductOverviewCardSwiperProps) => {
  return (
    <SwiperItemContainer
      slideItemWidth={SLIDE_WIDTH}
      slideItems={products.map((product, index) => (
        <ProductOverviewCard
          key={product.id}
          product={product as IProductForOverviewCard}
          pageType={pageType}
          index={index}
        />
      ))}
      extraElement={{
        width: 150,
        element: <GoToListPageButton renderedIn={pageType} itemType={category} height={SLIDE_HEIGHT} />,
      }}
    />
  );
};
